import API from '../lib/API';
import { UpdateUserPassword } from './contracts/AuthenticationServiceContract';

export function updateUserPassword(
    id: User.Model['id'],
    body: UpdateUserPassword.Body
): Promise<UpdateUserPassword.Response> {
    return API.patch(`/user/${id}/update-password`, body);
}